<template>
  <div class="diagnosis-result">
     <div v-if="diagnosisResult">
    
    <!-- 风险等级 -->
    <div class="card-container risk-card">
      <div class="risk-levels">
        <div 
          class="risk-col" 
          v-for="(lvl, index) in riskLevels" 
          :key="index"
        >
          <!-- 当前指示器 -->
          <div class="current-indicator-wrapper">
            <div class="current-indicator" v-if="diagnosisResult.riskLevel === lvl.name">
              <span class="current-text">当前</span>
              <div class="triangle-down"></div>        
            </div>
          </div>
          
          <div class="risk-bar" :style="{ backgroundColor: lvl.color }"></div>
          <div class="risk-label">{{ lvl.name }}</div>
        </div>
      </div>

      <div class="result-text-section">
        <div class="result-title" v-if="diagnosisResult.result">
          <span class="label-bold">检测结果：</span>
          <span class="result-value">{{ diagnosisResult.result }}</span>
        </div>
        <div class="result-reason" v-if="diagnosisResult.reason">
          <span class="label-bold">形成原因：</span>
          <span class="reason-text">{{ diagnosisResult.reason }}</span>
        </div>
      </div>
    </div>

    <!-- 舌诊解析 -->
    <div class="card-container">   
      <div class="card-header-center">
        <img src="https://pro-yeahgo-oss.yeahgo.com/file/zywzimg/舌诊解析.png" alt="舌诊解析" class="header-icon" />
        <span class="header-title">舌诊解析</span>
      </div>

      <div class="tongue-images">
        <div class="tongue-img-box">
          <img src="https://pro-yeahgo-oss.yeahgo.com/file/zywzimg/舌诊解析_标记.png" class="real-img" alt="正常舌象" />
          <div class="img-label">正常舌象</div>
        </div>
        <div class="tongue-img-box">
          <div class="tongue-preview">
            <img src="https://pro-yeahgo-oss.yeahgo.com/file/zywzimg/舌诊解析_正常舌头.png" class="real-img tongue-base-img" alt="您的舌象" />
            <img
              v-for="(item, index) in tongueExamples"
              :key="item.name"
              :src="item.img"
              :alt="item.name"
              class="tongue-example-img"
              :class="`tongue-example-img-${index + 1}`"
            />
          </div>
          <div class="img-label">您的舌象</div>
        </div>
      </div>

      

      <!-- 结果表格 -->
      <div class="result-table">
        <div class="table-header">
          <div class="th-cell">指标</div>
          <div class="th-cell">检测结果</div>
          <div class="th-cell">正常参考值</div>
        </div>
        <div class="table-row" v-for="(row, index) in tableData" :key="index">
          <div class="td-cell">{{ row.name }}</div>
          <div class="td-cell" :class="{'is-warn': row.result !== row.standard && row.result !== '无'}">
            {{ row.result || '无' }}
          </div>
          <div class="td-cell">{{ row.standard }}</div>
        </div>
      </div>

      <!-- 详细指标分析 -->
      <div class="detail-analysis-list">
        
        <!-- 舌色 -->
        <div class="analysis-section" v-if="diagnosisResult.tongueColor">
          <div class="section-title">
            <span class="dot"></span> 舌色（正常：淡红舌）
          </div>
          <div class="scale-bar-wrapper">
            <div class="scale-bar">
              <div 
                class="scale-segment" 
                v-for="(item, idx) in tongueColorScale" 
                :key="idx" 
                :style="{ backgroundColor: item.color }"
              >
                <div class="scale-indicator" v-if="diagnosisResult.tongueColor.result === item.name" :style="{ borderColor: item.color }"></div>
              </div>
            </div>
            <div class="scale-labels">
              <div class="scale-label" v-for="(item, idx) in tongueColorScale" :key="idx">{{ item.name }}</div>
            </div>
          </div>
          <div class="analysis-text-block">
            <div class="text-label">舌色分析：</div>
            <div class="text-content">{{ diagnosisResult.tongueColor.tongueColorAnalysis }}</div>
          </div>
          <div class="analysis-text-block">
            <div class="text-label">病理意义：</div>
            <div class="text-content">{{ diagnosisResult.tongueColor.pathologicalSignificance }}</div>
          </div>
        </div>

        <div class="divider-line"></div>

        <!-- 舌形 -->
        <div class="analysis-section" v-if="diagnosisResult.tongueShape">
          <div class="section-title">
            <span class="dot"></span> 舌形（正常：无）
          </div>
          <div class="tags-wrapper">
            <div class="tag active-tag">{{ diagnosisResult.tongueShape.shape || '无' }}</div>
          </div>
          <div class="analysis-text-block">
            <div class="text-label">舌形分析：</div>
            <div class="text-content">{{ diagnosisResult.tongueShape.tongueShapeAnalysis }}</div>
          </div>
          <div class="analysis-text-block">
            <div class="text-label">病理意义：</div>
            <div class="text-content">{{ diagnosisResult.tongueShape.pathologicalSignificance }}</div>
          </div>
        </div>

        <div class="divider-line"></div>

        <!-- 苔色 -->
        <div class="analysis-section" v-if="diagnosisResult.coatingColor">
          <div class="section-title">
            <span class="dot"></span> 苔色（正常：白苔）
          </div>
          <div class="scale-bar-wrapper">
            <div class="scale-bar">
              <div 
                class="scale-segment" 
                v-for="(item, idx) in coatingColorScale" 
                :key="idx" 
                :style="{ backgroundColor: item.color }"
              >
                <div class="scale-indicator" v-if="diagnosisResult.coatingColor.result === item.name" :style="{ borderColor: item.color }"></div>
              </div>
            </div>
            <div class="scale-labels">
              <div class="scale-label" v-for="(item, idx) in coatingColorScale" :key="idx">{{ item.name }}</div>
            </div>
          </div>
          <div class="analysis-text-block">
            <div class="text-label">苔色分析：</div>
            <div class="text-content">{{ diagnosisResult.coatingColor.coatingColorAnalysis }}</div>
          </div>
          <div class="analysis-text-block">
            <div class="text-label">病理意义：</div>
            <div class="text-content">{{ diagnosisResult.coatingColor.pathologicalSignificance }}</div>
          </div>
        </div>

        <div class="divider-line"></div>

        <!-- 苔质 -->
        <div class="analysis-section" v-if="diagnosisResult.coatingTexture">
          <div class="section-title">
            <span class="dot"></span> 苔质（正常：薄苔）
          </div>
          <div class="tags-wrapper">
            <div class="tag active-tag">{{ diagnosisResult.coatingTexture.result || '薄苔' }}</div>
          </div>
          <div class="analysis-text-block">
            <div class="text-label">苔质分析：</div>
            <div class="text-content">{{ diagnosisResult.coatingTexture.coatingTextureAnalysis }}</div>
          </div>
          <div class="analysis-text-block">
            <div class="text-label">病理意义：</div>
            <div class="text-content">{{ diagnosisResult.coatingTexture.pathologicalSignificance }}</div>
          </div>
        </div>

        <div class="divider-line"></div>

        <!-- 津液 -->
        <div class="analysis-section" v-if="diagnosisResult.bodyFluid">
          <div class="section-title">
            <span class="dot"></span> 津液（正常：润）
          </div>
          <div class="scale-bar-wrapper">
            <div class="scale-bar">
              <div 
                class="scale-segment" 
                v-for="(item, idx) in bodyFluidScale" 
                :key="idx" 
                :style="{ backgroundColor: item.color }"
              >
                <div class="scale-indicator" v-if="diagnosisResult.bodyFluid.result === item.name" :style="{ borderColor: item.color }"></div>
              </div>
            </div>
            <div class="scale-labels">
              <div class="scale-label" v-for="(item, idx) in bodyFluidScale" :key="idx">{{ item.name }}</div>
            </div>
          </div>
          <div class="analysis-text-block">
            <div class="text-label">津液分析：</div>
            <div class="text-content">{{ diagnosisResult.bodyFluid.bodyFluidAnalysis }}</div>
          </div>
          <div class="analysis-text-block">
            <div class="text-label">病理意义：</div>
            <div class="text-content">{{ diagnosisResult.bodyFluid.pathologicalSignificance }}</div>
          </div>
        </div>

        <div class="divider-line"></div>

        <!-- 舌下脉络 -->
        <div class="analysis-section" v-if="diagnosisResult.sublingualVessels">
          <div class="section-title">
            <span class="dot"></span> 舌下脉络（正常：正常）
          </div>
          <div class="scale-bar-wrapper">
            <div class="scale-bar">
              <div 
                class="scale-segment" 
                v-for="(item, idx) in sublingualScale" 
                :key="idx" 
                :style="{ backgroundColor: item.color }"
              >
                <div class="scale-indicator" v-if="diagnosisResult.sublingualVessels.result === item.name" :style="{ borderColor: item.color }"></div>
              </div>
            </div>
            <div class="scale-labels">
              <div class="scale-label" v-for="(item, idx) in sublingualScale" :key="idx">{{ item.name }}</div>
            </div>
          </div>
          <div class="analysis-text-block">
            <div class="text-label">舌下脉络分析：</div>
            <div class="text-content">{{ diagnosisResult.sublingualVessels.sublingualVesselsAnalysis }}</div>
          </div>
        </div>

      </div>

      <!-- 底部声明 -->
      <div class="bottom-statement">
        重要声明：本报告采用AI人工智能分析总结，仅供参考，不可作为医疗诊断结论。如已有身体不适，请及时咨询医生。
        <div class="time-text" v-if="reportData.createAt">生成时间：{{ reportData.createAt }}</div>
      </div>

    </div>

    <div v-else class="empty-state">
      <van-empty description="暂无诊断结果数据" />
    </div>
  </div>
</template>

<script>
import { Empty } from 'vant';

export default {
  name: 'DiagnosisResult',
  components: {
    [Empty.name]: Empty
  },
  props: {
    reportData: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    diagnosisResult() {
      return this.reportData?.tongueReport?.diagnosisResult || null;
    },
    tongueExamples() {
      const exampleList = this.reportData?.tongueExample;
      if (Array.isArray(exampleList) && exampleList.length) {
        return exampleList.slice(0, 4);
      }
      return this.defaultTongueExample;
    },
    tableData() {
      if (!this.diagnosisResult) return [];
      return [
        { name: '舌色', result: this.diagnosisResult.tongueColor?.result, standard: this.diagnosisResult.tongueColor?.standardValue || '淡红舌' },
        { name: '舌形', result: this.diagnosisResult.tongueShape?.shape, standard: '无' },
        { name: '苔色', result: this.diagnosisResult.coatingColor?.result, standard: '白苔' },
        { name: '苔质', result: this.diagnosisResult.coatingTexture?.result, standard: '薄苔' },
      ];
    }
  },
  data() {
    return {
      riskLevels: [
        { name: '较低风险', color: '#75CAE2' },
        { name: '中风险', color: '#92CF9C' },
        { name: '中高风险', color: '#FF8C58' },
        { name: '较高', color: '#FF5001' }
      ],
      tongueColorScale: [
        { name: '淡白', color: '#F3D0D0' },
        { name: '淡红', color: '#E59B9B' },
        { name: '红', color: '#D24D4D' },
        { name: '绛红', color: '#8B0000' },
        { name: '青紫', color: '#4B0082' }
      ],
      coatingColorScale: [
        { name: '无苔色', color: '#F5E6D3' },
        { name: '白苔', color: '#E5E5E5' },
        { name: '黄苔', color: '#FFD700' },
        { name: '灰黑苔', color: '#696969' }
      ],
      bodyFluidScale: [
        { name: '润', color: '#75CAE2' },
        { name: '滑', color: '#92CF9C' },
        { name: '燥', color: '#FF5001' }
      ],
      sublingualScale: [
        { name: '正常', color: '#E5E5E5' },
        { name: '青紫曲张', color: '#4B0082' }
      ],
      defaultTongueExample: [
        {
          name: '舌色',
          img: 'https://pro-yeahgo-oss.yeahgo.com/file/zywzimg/舌诊解析_0005_舌色2-.png',
          standard: '淡红色',
          result: '淡红'
        },
        {
          name: '舌形',
          img: 'https://pro-yeahgo-oss.yeahgo.com/file/zywzimg/舌诊解析_0001_舌形2.png',
          standard: '无',
          result: '无特殊明显形状'
        },
        {
          name: '苔色',
          img: 'https://pro-yeahgo-oss.yeahgo.com/file/zywzimg/舌诊解析_0008_苔色1.png',
          standard: '白苔',
          result: '白苔'
        },
        {
          name: '苔质',
          img: 'https://pro-yeahgo-oss.yeahgo.com/file/zywzimg/舌诊解析_0004_苔质1.png',
          standard: '薄苔',
          result: '薄苔'
        }
      ]
    };
  }
}
</script>

<style lang="scss" scoped>
.card-container {
  background: #fff;
  border-radius: 12px;
  padding: 20px 16px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.05);
  margin-bottom: 16px;
}

/* 风险等级区 */
.risk-levels {
  display: flex;
  justify-content: space-between;
  margin-bottom: 24px;
  padding-top: 24px;
}
.risk-col {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  margin: 0 4px;
}
.current-indicator-wrapper {
  height: 30px;
  position: absolute;
  top: -32px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.current-indicator {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.current-text {
  background: #fff;
  border: 1px solid #44C2C4;
  color: #44C2C4;
  font-size: 12px;
  padding: 2px 8px;
  border-radius: 4px;
}
.triangle-down {
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid #44C2C4;
  margin-top: -1px;
}
.risk-bar {
  width: 100%;
  height: 8px;
  border-radius: 4px;
  margin-bottom: 8px;
}
.risk-label {
  font-size: 12px;
  color: #666;
}

/* 结果文本区 */
.result-text-section {
  font-size: 14px;
  line-height: 1.6;
  color: #333;
}
.result-title {
  margin-bottom: 8px;
}
.label-bold {
  font-weight: bold;
}
.result-value {
  font-weight: bold;
}
.result-reason {
  color: #666;
  text-align: justify;
}

/* 卡片标题 */
.card-header-center {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}
.header-icon {
  width: 30px;
  height: 30px;
  margin-right: 8px;
  object-fit: contain;
}
.header-title {
  font-size: 18px;
  font-weight: bold;
  color: #333;
}

/* 舌象图片区 */
.tongue-images {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}
.tongue-img-box {
  width: 48%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.tongue-preview {
  position: relative;
  width: 100%;
}
.img-placeholder, .real-img {
  width: 100%;
  height: 140px;
  border-radius: 8px;
  object-fit: cover;
  margin-bottom: 8px;
}
.tongue-base-img {
  margin-bottom: 0;
}
.tongue-example-img {
  position: absolute;
  width: auto;
  max-width: 30px;
  height: 12px;
  border-radius: 4px;
  object-fit: contain;
  border: 0;
  box-shadow: none;
  background: transparent;
  padding: 0;
  box-sizing: border-box;
}
.tongue-example-img-1 {
  top: 56px;
  left: 2px;
}
.tongue-example-img-2 {
  top: 92px;
  left: 2px;
}
.tongue-example-img-3 {
  bottom: 8px;
  left: 18px;
}
.tongue-example-img-4 {
  bottom: 8px;
  right: 16px;
}
.img-label {
  font-size: 14px;
  color: #333;
}

/* 结果表格 */
.result-table {
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 24px;
  border: 1px solid #e5e5e5;
}
.table-header {
  display: flex;
  background: #44C2C4;
  color: #fff;
  font-weight: bold;
}
.table-row {
  display: flex;
  background: #fff;
  border-top: 1px solid #e5e5e5;
}
.table-row:nth-child(even) {
  background: #fcfcfc;
}
.th-cell, .td-cell {
  flex: 1;
  text-align: center;
  padding: 12px 8px;
  font-size: 14px;
}
.td-cell {
  color: #333;
}
.is-warn {
  color: #EE0A24; /* 异常标红 */
}

/* 详细指标分析 */
.detail-analysis-list {
  display: flex;
  flex-direction: column;
}
.analysis-section {
  padding: 8px 0;
}
.section-title {
  font-size: 16px;
  font-weight: bold;
  color: #333;
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}
.dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #D0A77A;
  margin-right: 8px;
}

/* 分段刻度条 */
.scale-bar-wrapper {
  margin-bottom: 16px;
}
.scale-bar {
  display: flex;
  height: 6px;
  border-radius: 3px;
  margin-bottom: 8px;
}
.scale-segment {
  flex: 1;
  position: relative;
}
.scale-segment:first-child {
  border-radius: 3px 0 0 3px;
}
.scale-segment:last-child {
  border-radius: 0 3px 3px 0;
}
.scale-indicator {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 12px;
  height: 12px;
  background: #fff;
  border: 2px solid;
  border-radius: 50%;
  z-index: 2;
}
.scale-labels {
  display: flex;
}
.scale-label {
  flex: 1;
  text-align: center;
  font-size: 12px;
  color: #666;
}

/* 标签 (如舌形) */
.tags-wrapper {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 16px;
}
.tag {
  padding: 6px 16px;
  border-radius: 16px;
  font-size: 13px;
  color: #666;
  border: 1px solid #e5e5e5;
}
.active-tag {
  background: #44C2C4;
  color: #fff;
  border-color: #44C2C4;
}

/* 分析文本块 */
.analysis-text-block {
  margin-bottom: 12px;
}
.text-label {
  font-size: 14px;
  font-weight: bold;
  color: #333;
  margin-bottom: 4px;
}
.text-content {
  font-size: 14px;
  color: #666;
  line-height: 1.6;
  text-align: justify;
}

/* 分割线 */
.divider-line {
  height: 1px;
  background: #e5e5e5;
  margin: 16px 0;
}

/* 底部声明 */
.bottom-statement {
  font-size: 12px;
  color: #999;
  line-height: 1.6;
  text-align: justify;
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px dashed #e5e5e5;
}
.time-text {
  margin-top: 4px;
}
</style>